module.exports = __webpack_public_path__ + "img/40_38_031_140.1bba2309.jpg";